<template>
  <editor-form :can-back="true" @submit.prevent="showConfirmModal" @back="toViewer">
    <vuex-text-form-item label="氏名" bind="name" :required="true" />
    <vuex-text-form-item label="氏名（カナ）" bind="name_kana" :required="true" />
    <vuex-switch-form-item label="管理者" bind="is_supervisor" />
    <text-browse-item label="メールアドレス" :value="email" />
    <vuex-password-form-item bind="password" placeholder="変更する場合のみパスワード入力" label="新しいパスワード" />
    <vuex-switch-form-item label="２段階認証" bind="use_two_step_authentication" />
    <vuex-textarea-form-item bind="contact" label="連絡先" />
    <vuex-text-form-item label="店舗名" bind="office" />
    <vuex-text-form-item label="部署名" bind="department" />
    <danger-alert v-if="conflictUser" message="同じメールアドレスのユーザーがすでに存在します" />
    <danger-alert v-if="freezeAlertMessage" :message="freezeAlertMessage" />
    <template #expansion-buttons-right>
      <freeze-button v-if="status===$constant.BROKER_STATUS.ENABLED" @click="$refs.freezeConfirmModal.show()" />
      <restore-button v-if="status===$constant.BROKER_STATUS.DISABLED" @click="$refs.restoreConfirmModal.show()" />
    </template>
  </editor-form>
  <teleport to="body">
    <edit-confirm-modal @update="doUpdate" ref="confirmModal" />
    <freeze-confirm-modal @freeze="doFreeze" ref="freezeConfirmModal" />
    <restore-confirm-modal @restore="doRestore" ref="restoreConfirmModal" />
  </teleport>
</template>

<script>
import {mapState} from "vuex";
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import EditorForm from "@/views/templates/forms/EditorForm";
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import VuexPasswordFormItem from "@/views/molecules/formItems/VuexPasswordFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import VuexSwitchFormItem from "@/views/molecules/formItems/VuexSwitchFormItem";
import FreezeButton from '@/views/molecules/buttons/FreezeButton'
import RestoreButton from '@/views/molecules/buttons/RestoreButton'
import EditConfirmModal from "@/views/molecules/modals/EditConfirmModal";
import FreezeConfirmModal from '@/views/molecules/modals/FreezeConfirmModal'
import RestoreConfirmModal from '@/views/molecules/modals/RestoreConfirmModal'
import DangerAlert from '@/views/atoms/alerts/DangerAlert'

export default {
  name: "BrokerEditor",
  components: {
    EditorForm,
    VuexTextFormItem,
    TextBrowseItem,
    VuexPasswordFormItem,
    VuexTextareaFormItem,
    VuexSwitchFormItem,
    FreezeButton,
    RestoreButton,
    EditConfirmModal,
    FreezeConfirmModal,
    RestoreConfirmModal,
    DangerAlert,
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'broker_form'
  },
  inject: [
    '$constant',
  ],
  data() {
    return {
      conflictUser: false,
      freezeAlertMessage: null
    }
  },
  computed: {
    ...mapState('broker_form', {
      status: state => state.data.status,
      email: state => state.data.email
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('broker_form/load', {id: this.$route.params.id}).catch(() => this.$root.failApi());
    },
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doUpdate() {
      this.$store.dispatch('broker_form/update', {id: this.$route.params.id}).then(() => {
        this.$router.push({name: 'BrokerViewer'});
      }).catch(reason => this.$root.failApi(reason));
    },
    doFreeze() {
      this.$store.dispatch('broker_form/freeze', {id: this.$route.params.id}).then(() => {
        this.$router.push({name: 'BrokerViewer'});
      }).catch((message) => {
        if (message) {
          this.freezeAlertMessage = message
        } else {
          this.$root.failApi()
        }
      });
    },
    doRestore() {
      this.$store.dispatch('broker_form/restore', {id: this.$route.params.id}).then(() => {
        this.$router.push({name: 'BrokerViewer'});
      }).catch(reason => {
        if (reason?.conflict) {
          this.conflictUser = true;
        } else {
          this.$root.failApi(reason);
        }
      });
    },
    toViewer() {
      this.$router.push({name: 'BrokerViewer'});
    },
  }
}
</script>
